import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#5D3FD3] text-white-400 text-sm py-8">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 mb-6">
          <div className="text-center md:text-left">
            <p>&copy; {new Date().getFullYear()} MediCoin. All rights reserved.</p>
          </div>
          
          <div className="flex flex-wrap justify-center gap-6">
            <Link
              to="/privacy-policy"
              className="text-white/80 hover:text-white transition duration-200"
            >
              Privacy Policy
            </Link>
            <span className="text-white/40">•</span>
            <Link
              to="/terms-of-use"
              className="text-white/80 hover:text-white transition duration-200"
            >
              Terms of Use
            </Link>
            <span className="text-white/40">•</span>
            <a
              href="mailto:support@medicureon.com"
              className="text-white/80 hover:text-white transition duration-200"
            >
              Contact
            </a>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 pb-6">
          <div className="flex flex-wrap justify-center gap-4 md:gap-6 text-xs md:text-sm mb-6">
            <a
              href="https://www.medicureon.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-purple-200 hover:text-purple-100 transition duration-200 font-semibold"
            >
              🌐 MediCureOn Website
            </a>
            <span className="text-white/30">•</span>
            <a
              href="https://hub.medicureon.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-purple-200 hover:text-purple-100 transition duration-200 font-semibold"
            >
              📚 MediCureOn Hub
            </a>
            <span className="text-white/30">•</span>
            <a
              href="https://platform.medicureon.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-purple-200 hover:text-purple-100 transition duration-200 font-semibold"
            >
              💻 Wellness Platform
            </a>
          </div>
        </div>
        
        <div className="border-t border-white/10 pt-6 text-center text-white/60 text-xs space-y-4">
          <p>MediCoin is a utility token powering the MediCureOn healthcare ecosystem.</p>
          <p>Always do your own research (DYOR) before participating in any ICO.</p>
          
          <div className="pt-6 border-t-2 border-purple-500/50 mt-8">
            <div className="bg-gradient-to-r from-purple-600/20 to-indigo-600/20 rounded-lg p-6 backdrop-blur-sm border border-purple-500/30">
              <p className="text-white font-bold text-sm md:text-base leading-relaxed">
                🏗️ All MediCureOn products & Services<br />
                <span className="text-purple-300 text-base md:text-lg">Powered by <strong>Microsoft & Nvidia AI</strong></span><br />
                <span className="text-indigo-300">Sponsored by <strong>Microsoft Startups Founders Hub</strong></span><br />
                <span className="text-green-300 font-semibold">📱 iOS App Coming Soon on the Apple Store</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
